import { Button, Stack } from '@mui/material';
import type { ReactNode } from 'react';
import { _ } from '/@/locale';

interface EditActionsProps {
    onCancel: () => void;
    onSave: () => void;
    saveDisabled?: boolean;
    cancelDisabled?: boolean;
    /** Save button color — `secondary` (CTA accent) for the form cards, `primary` for inline edits. */
    saveColor?: 'primary' | 'secondary';
    cancelVariant?: 'text' | 'outlined';
    size?: 'small' | 'medium';
    saveStartIcon?: ReactNode;
    saveEndIcon?: ReactNode;
}

/** Right-aligned Cancelar / Guardar button pair shared by the editable registry cards. */
export const EditActions = ({
    onCancel,
    onSave,
    saveDisabled = false,
    cancelDisabled = false,
    saveColor = 'primary',
    cancelVariant = 'outlined',
    size,
    saveStartIcon,
    saveEndIcon,
}: EditActionsProps) => (
    <Stack direction='row' spacing={1} justifyContent='flex-end'>
        <Button variant={cancelVariant} color='primary' onClick={onCancel} disabled={cancelDisabled} size={size}>
            {_('Cancelar')}
        </Button>
        <Button
            variant='contained'
            color={saveColor}
            onClick={onSave}
            disabled={saveDisabled}
            size={size}
            startIcon={saveStartIcon}
            endIcon={saveEndIcon}
        >
            {_('Guardar')}
        </Button>
    </Stack>
);
